import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { WorkLevel, WorkLevelItem } from '../models/workLevel';
import { tabVerifyData, VerifyInterface } from '../models/tabverify';
import { store } from './store';
import { Activity } from '../models/activity';
import { MetaDataElement } from '../models/metaDataConfig';

export default class WorkLevelStore {
  workLevelRegistry = new Map<string, WorkLevel>();
  workLevelRegistryAll = new Map<string, WorkLevel>();
  itemClonedDatas: VerifyInterface = tabVerifyData;
  currentTabVerify: VerifyInterface = tabVerifyData;
  selectedworkLevel: WorkLevel | undefined = undefined;
  selectedWorkLevelItemsForName: Activity[] | [] = [];
  selectedWorkLevelItem: WorkLevelItem | undefined = undefined;
  workLevelMastersRegistry = new Map<string, WorkLevelItem>();
  reloadMastersCall: boolean = false;
  loadingMasterComponent: boolean = false;
  loadAllMastersTitleDetails: string[] = [];

  formDetails: MetaDataElement[] = [];

  viewItemGroups: {
    isloading: boolean;
    pageNumber: number;
    count: number;
    data: {
      id: string;
      title: string;
    }[];
  } = {
    count: 0,
    isloading: false,
    pageNumber: 1,
    data: [],
  };

  selctedWL: any | undefined = undefined;
  //    workLevelTitle:GetWorklevel[]|[]=[];
  loadingInitial = false;
  loading = false;
  loadingMastersAlone = false;
  itemNames: any[] = [];
  masterReportsId: string = '';

  constructor() {
    makeAutoObservable(this);
  }
  get workLevelitemsByDate() {
    return Array.from(this.workLevelRegistry.values());
  }
  get workLevelitemsByDateAll() {
    return Array.from(this.workLevelRegistryAll.values());
  }

  get MastersWorkLevelAll() {
    return Array.from(this.workLevelMastersRegistry.values());
  }

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setWorkLevel = (WorkLevel: WorkLevel) => {
    this.workLevelRegistry.set(WorkLevel.id, WorkLevel);
  };

  private setWorkLevelAll = (WorkLevel: WorkLevel) => {
    this.workLevelRegistryAll.set(WorkLevel.id, WorkLevel);
  };
  private setMastersWorkLevelAll = (WorkLevel: WorkLevelItem) => {
    this.workLevelMastersRegistry.set(WorkLevel.id, WorkLevel);
  };

  private getWorkLevel = (id: string) => {
    return this.workLevelRegistry.get(id);
  };

  loadWorkLevels = async () => {
    this.loadingInitial = true;
    try {
      const workLevelDetails = await agent.WorkLevels.listAll();

      runInAction(() => {
        workLevelDetails.forEach((workLevelDetails) => {
          this.setWorkLevelAll(workLevelDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  viewItemGroupSearchDetails = async (
    searchvalue: string,
    PageNumber: number,
    pageSize?: number,
  ) => {
    try {
      this.viewItemGroups = {
        ...this.viewItemGroups,
        isloading: true,
      };
      let [searchDetails, countDetails] = await Promise.all([
        agent.WorkLevels.viewItemGroupsSearchAPI({
          searchvalue,
          PageNumber,
          PageSize: pageSize ? pageSize : 5,
        }),
        agent.WorkLevels.viewItemGroupsCountAPI({
          searchvalue: searchvalue,
        }),
      ]);
      runInAction(() => {
        this.viewItemGroups = {
          ...this.viewItemGroups,
          count: countDetails.data,
          data: searchDetails.data,
          isloading: false,
          pageNumber: PageNumber,
        };
      });
    } catch (error) {
      this.viewItemGroups = {
        ...this.viewItemGroups,
        isloading: false,
      };
    }
  };

  viewItemGroupSortDetails = async (orderBy: string, PageNumber: number) => {
    try {
      this.viewItemGroups = {
        ...this.viewItemGroups,
        isloading: true,
      };
      let searchDetails = await agent.WorkLevels.viewItemGroupsSortAPI({
        orderBy,
        PageNumber,
        PageSize: 5,
      });
      runInAction(() => {
        this.viewItemGroups = {
          ...this.viewItemGroups,
          data: searchDetails.data,
          isloading: false,
        };
      });
    } catch (error) {
      this.viewItemGroups = {
        ...this.viewItemGroups,
        isloading: false,
      };
    }
  };

  loadWorkLevel = async (id: string) => {
    if (id === '') {
      this.selectedworkLevel = undefined;
    } else {
      this.loadingInitial = true;
      try {
        const WorkLevel = await agent.WorkLevels.details(id);
        runInAction(() => {
          this.selctedWL = WorkLevel;
          this.selectedworkLevel = WorkLevel;
          this.setWorkLevel(WorkLevel);
          store.dashboardStore.setWorkLevelMaster(WorkLevel);
        });
        this.setLoadingInitial(false);
        return WorkLevel;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  loadWorkLevelWithItem = async (id: string) => {
    if (id === '') {
      this.selectedWorkLevelItem = undefined;
    } else {
      this.loadingInitial = true;

      try {
        this.loadingMasterComponent = true;
        const WorkLevel = await agent.WorkLevels.detailsItem(id);
        runInAction(() => {
          // this.selctedWL = WorkLevel
          this.selectedWorkLevelItem = WorkLevel;
          // this.setWorkLevel(WorkLevel);
          // store.dashboardStore.setWorkLevelMaster(WorkLevel);
        });
        this.loadingMasterComponent = false;
        this.setLoadingInitial(false);
        return WorkLevel;
      } catch (error) {
        this.loadingMasterComponent = false;
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  createWorkLevel = async (WorkLevel: WorkLevel) => {
    this.loading = true;
    try {
      await agent.WorkLevels.create(WorkLevel);

      runInAction(() => {
        this.workLevelRegistry.set(WorkLevel.id, WorkLevel);
        this.workLevelRegistryAll.set(WorkLevel.id, WorkLevel);
        this.loading = false;
      });
      toast.success('WorkLevel Record Created Successfully ');
      this.reloadMastersCall = !this.reloadMastersCall;
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  updateWorkLevel = async (WorkLevel: WorkLevel) => {
    this.loading = true;

    try {
      await agent.WorkLevels.update(WorkLevel);

      runInAction(() => {
        this.workLevelRegistry.set(WorkLevel.id, WorkLevel);
        this.workLevelRegistryAll.set(WorkLevel.id, WorkLevel);
        this.selectedworkLevel = WorkLevel;
        // this.editMode = false;
        this.loading = false;
      });
      toast.success('WorkLevel  Updated Succesfully.');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  deleteWorkLevel = async (WorkLevel: WorkLevel) => {
    try {
      await agent.WorkLevels.delete(WorkLevel);
      runInAction(() => {
        this.workLevelRegistry.delete(WorkLevel.id);
        this.workLevelRegistryAll.delete(WorkLevel.id);
      });
      toast.success('WorkLevel Deleted Succesfully.');
      this.viewItemGroupSearchDetails('', 1);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        toast.error('WorkLevel Cannot Be Deleted.');
      });
    }
  };
  loadWorkLevelBasedOnItemLevel = async (id: string) => {
    try {
      if (id !== undefined) {
        const worklevelName = await agent.WorkLevels.worklevelFromItem(id);
        runInAction(() => {
          store.dashboardStore.dashboard.dashboardWorkLevelMaster = {
            id: worklevelName.id,
            title: worklevelName.title,
            year: worklevelName.year,
            language: worklevelName.language,
            originIndia: worklevelName.originIndia,
            isActive: true,
            isDeleted: false,
            isMaster: worklevelName.isMaster,
          };
          this.selectedworkLevel = worklevelName;
          this.selectedWorkLevelItemsForName = worklevelName.items;
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //load Clone For Items
  loadCloneData = async (payload: any) => {
    const clonedData = await agent.WorkLevels.loadClone(payload);
    if (clonedData.data) {
      this.itemClonedDatas = clonedData.data;
    } else {
      this.itemClonedDatas = tabVerifyData;
    }
  };

  setCurrentTabVerify = (e: VerifyInterface) => {
    this.currentTabVerify = e;
  };

  loadItemNames = async (id: any) => {
    try {
      const itemDetails = await agent.WorkLevels.loadName(id);
      runInAction(() => {
        this.itemNames = itemDetails;
      });
      return itemDetails;
    } catch (error) {
      console.log(error);
    }
  };
  loadAllMasters = async () => {
    try {
      const MasterDetails: any = await agent.WorkLevels.loadMasters();
      runInAction(() => {
        MasterDetails.forEach((element: WorkLevelItem) => {
          this.setMastersWorkLevelAll(element);
        });
      });
      return MasterDetails;
    } catch (error) {
      console.log(error);
    }
  };
  loadAllMasterTitles = async () => {
    try {
      let MasterTitles = await agent.WorkLevels.getAllMasterTitles();
      runInAction(() => {
        if (MasterTitles) {
          this.loadAllMastersTitleDetails = MasterTitles.map(function (
            x: string,
          ) {
            return x.toLowerCase();
          });
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
}
